import React from "react";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import ConfigSection from "../../components/setting-page/ConfigSection.tsx";

const ConfigPage = () => {
  useAppSettings();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [activeSection, setActiveSection] = React.useState("general");
  const isManualScroll = React.useRef(false);
  const scrollTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const sections = [
    { id: "general", label: "General", icon: "fa-gear" },
    { id: "ordenamiento", label: "Ordenamiento", icon: "fa-arrows-up-down" },
    { id: "insignias", label: "Insignias", icon: "fa-medal" },
  ];

  React.useEffect(() => {
    const handleScroll = () => {
      if (isManualScroll.current) {
        return;
      }

      const sections = document.querySelectorAll(
        '[id="general"], [id="ordenamiento"], [id="insignias"]'
      );
      const scrollPosition = window.scrollY + 200;

      let foundSection = false;
      sections.forEach((section) => {
        const element = section as HTMLElement;
        const offsetTop = element.offsetTop;
        const offsetHeight = element.offsetHeight;

        if (
          scrollPosition >= offsetTop &&
          scrollPosition < offsetTop + offsetHeight &&
          !foundSection
        ) {
          setActiveSection(element.id);
          foundSection = true;
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      isManualScroll.current = true;
      setActiveSection(sectionId);

      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      scrollTimeoutRef.current = setTimeout(() => {
        isManualScroll.current = false;
      }, 1000);
    }
  };

  return (
    <Layout loading={loading}>
      <Title
        baseTitle="Configuración"
        basePath="/configuracion"
        title="Configuración"
      />
      <div
        style={{
          padding: "20px",
          display: "flex",
          gap: "24px",
          maxWidth: "1800px",
          margin: "0 auto",
        }}
      >
        {/* Columna izquierda - Navegación */}
        <div
          className="d-none d-lg-block"
          style={{
            width: "280px",
            flexShrink: 0,
            position: "sticky",
            top: "120px",
            alignSelf: "flex-start",
            maxHeight: "calc(100vh - 140px)",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              background: "#f9fafb",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
              padding: "12px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#374151",
                marginBottom: "12px",
                padding: "0 4px",
                letterSpacing: "0.3px",
              }}
            >
              Navegación
            </div>
            <nav
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "12px 14px",
                    borderRadius: "8px",
                    border: "none",
                    background:
                      activeSection === section.id ? "#fff" : "transparent",
                    color: activeSection === section.id ? "#374151" : "#6b7280",
                    fontSize: "14px",
                    fontWeight: activeSection === section.id ? "600" : "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    textAlign: "left",
                    width: "100%",
                    borderLeft:
                      activeSection === section.id
                        ? "3px solid #374151"
                        : "3px solid transparent",
                    boxShadow:
                      activeSection === section.id
                        ? "0 2px 4px rgba(0, 0, 0, 0.05)"
                        : "none",
                  }}
                  onMouseEnter={(e) => {
                    if (activeSection !== section.id) {
                      e.currentTarget.style.background = "#fff";
                      e.currentTarget.style.color = "#374151";
                      e.currentTarget.style.boxShadow =
                        "0 1px 3px rgba(0, 0, 0, 0.05)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeSection !== section.id) {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.color = "#6b7280";
                      e.currentTarget.style.boxShadow = "none";
                    }
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background:
                        activeSection === section.id ? "#374151" : "#e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i
                      className={`fa-solid ${section.icon}`}
                      style={{
                        fontSize: "14px",
                        color:
                          activeSection === section.id ? "#fff" : "#6b7280",
                      }}
                    ></i>
                  </div>
                  <span>{section.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Columna derecha - Contenido */}
        <div style={{ flex: 1, minWidth: 0, paddingRight: "8px" }}>
          <ConfigSection />
        </div>
      </div>
    </Layout>
  );
};

export default ConfigPage;
